export const PROVIDERS = {
  ADSGRAM: 'adsgram',
  BARZHA: 'barzha',
  TADS: 'tads',
  TAPPADS: 'tappads',
  ONCLICK: 'onclick',
  ADEXTRA: 'adextra',
  RICHADS: 'richads',
  MONETAG: 'monetag',
} as const;

export interface BoostTask {
  id: string | number;
  title?: string;
  description?: string;
  icon?: string;
  provider: string;
  link?: string;
  onClick: () => Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  onShowReward?: () => Promise<boolean>;
}

export interface BoostProvider {
  getName(): string;
  getAvailableTasks(miningId: number): Promise<BoostTask[]>;
  startTask?(
    taskId: string | number,
  ): Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  resetError?(): void;
}

export interface IBoostProvider {
  showAd(): Promise<boolean>;
  getName(): string;
}

export interface ProviderWithPriority {
  provider: IBoostProvider;
  priority: number;
}
